const openClass = 'ac--open'

class HeroAutoComplete {
  constructor (elem) {
    this.elem = elem
    this.itemList = elem.querySelector('ul')

    this.elem.addEventListener('click', e => e.stopPropagation())
  }

  removeContents () {
    this.itemList.innerHTML = ''
  }

  returnItemDetails (item) {
    let breadcrumbHtml = ''

    if (item.breadcrumb) {
      breadcrumbHtml = `<div class="ac__item-bc">${item.breadcrumb.join(' -> ')}</div>`
    }

    return `<li class="ac__item">
      <a href="${item.url}" class="ac__link">
        <div class="ac__item-title">${item.title}</div>
        ${breadcrumbHtml}
      </a>
    </li>`
  }

  open (items) {
    this.elem.classList.add(openClass)
    if (items.length > 0) {
      this.itemList.innerHTML = items.map(x => this.returnItemDetails(x)).join('')
    } else {
      this.close(true)
    }
  }

  close (removeContents = true) {
    this.elem.classList.remove(openClass)

    if (removeContents) {
      this.removeContents()
    }
  }
}

export {
  HeroAutoComplete
}
